export const REFERRAL_CODE_STORAGE_KEY = "referral_code";
export const AFFILIATE_CODE_STORAGE_KEY = "affiliate_code";
export const ATTRIBUTION_CODE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
